import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25;

import { css, memoizeStyle, prefix } from "../../../lib/theming/Emotion";
import * as ColorFunctions from "../../../lib/styles/ColorFunctions";
import { tokenSizeMixin } from "../Token.mixins";
export var globalClasses = prefix('token')({
  removeIcon: 'remove-icon'
});
export var styles = memoizeStyle({
  token: function token(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-flex;\n      align-items: center;\n      border-radius: ", ";\n      min-width: 0;\n      word-break: break-all;\n      user-select: none;\n\n      &:hover {\n        cursor: pointer;\n      }\n    "])), t.tokenBorderRadius);
  },
  tokenSmall: function tokenSmall(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), tokenSizeMixin(t.tokenPaddingYSmall, t.tokenPaddingXSmall, t.tokenLineHeightSmall, t.tokenFontSizeSmall, t.tokenMarginYSmall, t.tokenMarginXSmall));
  },
  tokenMedium: function tokenMedium(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), tokenSizeMixin(t.tokenPaddingYMedium, t.tokenPaddingXMedium, t.tokenLineHeightMedium, t.tokenFontSizeMedium, t.tokenMarginYMedium, t.tokenMarginXMedium));
  },
  tokenLarge: function tokenLarge(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), tokenSizeMixin(t.tokenPaddingYLarge, t.tokenPaddingXLarge, t.tokenLineHeightLarge, t.tokenFontSizeLarge, t.tokenMarginYLarge, t.tokenMarginXLarge));
  },
  token2022: function token2022(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      border: solid ", " transparent;\n    "])), t.tokenBorderWidth);
  },
  tokenDefaultIdle2022: function tokenDefaultIdle2022(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n      background-clip: border-box;\n    "])), t.tokenDefaultIdleColor, t.tokenDefaultIdleBg, t.tokenDefaultIdleBorderColor);
  },
  tokenDefaultIdleHovering2022: function tokenDefaultIdleHovering2022(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      &:hover {\n        color: ", ";\n        background: ", ";\n        border: solid ", " ", ";\n      }\n    "])), t.tokenDefaultIdleColorHover, t.tokenDefaultIdleBgHover, t.tokenBorderWidth, t.tokenDefaultIdleBorderColorHover);
  },
  tokenDefaultActive2022: function tokenDefaultActive2022(t) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      background: ", ";\n      border: solid ", " ", ";\n    "])), t.tokenDefaultActiveColor, t.tokenDefaultActiveBg, t.tokenBorderWidth, t.tokenDefaultActiveBorderColor);
  },
  tokenError2022: function tokenError2022(t) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      border: solid ", " ", ";\n      box-shadow: 0 0 0 ", " ", ";\n    "])), t.tokenBorderWidth, t.tokenBorderColorError, t.tokenOutlineWidth, t.tokenBorderColorError);
  },
  tokenWarning2022: function tokenWarning2022(t) {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      border: solid ", " ", ";\n      box-shadow: 0 0 0 ", " ", ";\n    "])), t.tokenBorderWidth, t.tokenBorderColorWarning, t.tokenOutlineWidth, t.tokenBorderColorWarning);
  },
  tokenDisabled2022: function tokenDisabled2022(t) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      user-select: text;\n      cursor: text;\n      color: ", ";\n      pointer-events: none;\n      border: solid 1px ", ";\n\n      .", " {\n        visibility: hidden;\n      }\n    "])), t.tokenTextColorDisabled, t.tokenBorderColorDisabled, globalClasses.removeIcon);
  },
  disabled: function disabled(t) {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      user-select: text;\n      cursor: text;\n      color: ", ";\n      pointer-events: none;\n\n      .", " {\n        visibility: hidden;\n      }\n    "])), t.tokenTextColorDisabled, globalClasses.removeIcon);
  },
  text: function text(t) {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      padding-bottom: ", ";\n    "])), t.tokenLegacyTextShift);
  },
  removeIcon: function removeIcon(t) {
    return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n      height: ", ";\n      width: ", ";\n      flex-shrink: 0;\n      padding: ", " ", ";\n      box-sizing: ", ";\n      margin-left: ", ";\n      transition: none;\n      fill: currentColor;\n      opacity: 0.5;\n      line-height: 0;\n      display: inline-block;\n\n      &:hover {\n        opacity: 1;\n      }\n    "])), t.tokenRemoveIconSize, t.tokenRemoveIconSize, t.tokenRemoveIconPaddingY, t.tokenRemoveIconPaddingX, t.tokenRemoveIconBoxSizing, t.tokenRemoveIconGap);
  },
  helperText: function helperText() {
    return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n      max-width: 100%;\n      word-break: break-all;\n\n      // don't collapse spaces\n      // so they get counted in width\n      white-space: pre-wrap;\n    "])));
  },
  helperContainer: function helperContainer() {
    return css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      position: absolute;\n      visibility: hidden;\n    "])));
  },
  helperContainerSmall: function helperContainerSmall(t) {
    return css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n      left: ", ";\n      right: ", ";\n    "])), t.tokenInputPaddingXSmall, t.tokenInputPaddingXSmall);
  },
  helperContainerMedium: function helperContainerMedium(t) {
    return css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n      left: ", ";\n      right: ", ";\n    "])), t.tokenInputPaddingXMedium, t.tokenInputPaddingXMedium);
  },
  helperContainerLarge: function helperContainerLarge(t) {
    return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n      left: ", ";\n      right: ", ";\n    "])), t.tokenInputPaddingXLarge, t.tokenInputPaddingXLarge);
  }
});
export var colorStyles = [{
  name: 'defaultIdle',
  color: function color(t) {
    return t.tokenDefaultIdle;
  }
}, {
  name: 'defaultActive',
  color: function color(t) {
    return t.tokenDefaultActive;
  }
}, {
  name: 'grayIdle',
  color: function color(t) {
    return t.tokenGrayIdle;
  }
}, {
  name: 'grayActive',
  color: function color(t) {
    return t.tokenGrayActive;
  }
}, {
  name: 'blueIdle',
  color: function color(t) {
    return t.tokenBlueIdle;
  }
}, {
  name: 'blueActive',
  color: function color(t) {
    return t.tokenBlueActive;
  }
}, {
  name: 'greenIdle',
  color: function color(t) {
    return t.tokenGreenIdle;
  }
}, {
  name: 'greenActive',
  color: function color(t) {
    return t.tokenGreenActive;
  }
}, {
  name: 'yellowIdle',
  color: function color(t) {
    return t.tokenYellowIdle;
  }
}, {
  name: 'yellowActive',
  color: function color(t) {
    return t.tokenYellowActive;
  }
}, {
  name: 'redIdle',
  color: function color(t) {
    return t.tokenRedIdle;
  }
}, {
  name: 'redActive',
  color: function color(t) {
    return t.tokenRedActive;
  }
}, {
  name: 'white',
  color: function color(t) {
    return t.tokenWhite;
  }
}, {
  name: 'black',
  color: function color(t) {
    return t.tokenBlack;
  }
}].reduce(function (colors, _ref) {
  var _extends2;

  var name = _ref.name,
      color = _ref.color;
  return _extends({}, colors, (_extends2 = {}, _extends2[name] = function (t, v) {
    var getVStyle = function getVStyle() {
      if (v === 'error') {
        return css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n            box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n          "])), t.tokenOutlineWidth, t.tokenBorderColorError, color(t));
      } else if (v === 'warning') {
        return css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n            box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n          "])), t.tokenOutlineWidth, t.tokenBorderColorWarning, color(t));
      }

      return '';
    };

    return css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n        color: ", ";\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n\n        ", "\n\n        .", ":hover {\n          color: ", ";\n        }\n      "])), color(t), ColorFunctions.contrast(color(t)), t.tokenBorderWidth, ColorFunctions.darken(color(t), '5%'), color(t), getVStyle(), globalClasses.removeIcon, ColorFunctions.contrast(color(t)));
  }, _extends2));
}, {
  defaultDisabled: function defaultDisabled(t) {
    return css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n        box-shadow: ", ";\n      "])), t.tokenDisabledBg, t.tokenShadowDisabled);
  },
  defaultDisabledWarning: function defaultDisabledWarning(t) {
    return css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n      "])), t.tokenOutlineWidth, t.tokenBorderColorWarning, t.tokenDisabledBg);
  },
  defaultDisabledError: function defaultDisabledError(t) {
    return css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 0 0 ", " ", ", inset 0 0 0 1px ", ";\n      "])), t.tokenOutlineWidth, t.tokenBorderColorError, t.tokenDisabledBg);
  }
});